import firebase from "../config/firebase";

// Cache em memória compartilhado entre telas/componentes.
let driversCache = [];
// Controla se já recebemos ao menos um snapshot do banco.
let hasLoadedOnce = false;
// Guarda o unsubscribe do onSnapshot global.
let firestoreUnsubscribe = null;
// Lista de consumidores ativos do cache.
const listeners = new Set();

const notifyListeners = () => {
  const snapshot = {
    data: driversCache,
    hasLoadedOnce,
  };

  listeners.forEach((listener) => {
    try {
      listener(snapshot);
    } catch (error) {
      console.error("Erro ao notificar listener de motoristas:", error);
    }
  });
};

const ensureFirestoreListener = () => {
  // Garante apenas um listener global no Firestore.
  if (firestoreUnsubscribe) return;

  firestoreUnsubscribe = firebase
    .firestore()
    .collection("drivers_users")
    .onSnapshot(
      (result) => {
        // Atualiza o cache com a versão mais recente do banco.
        const nextDrivers = result.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        driversCache = nextDrivers;
        hasLoadedOnce = true;
        notifyListeners();
      },
      (error) => {
        console.error("Erro ao escutar motoristas em tempo real:", error);
      }
    );
};

export const subscribeDriversCache = (listener) => {
  if (typeof listener !== "function") {
    return () => {};
  }

  listeners.add(listener);
  // Inicia a escuta em tempo real na primeira inscrição.
  ensureFirestoreListener();

  if (hasLoadedOnce) {
    // Se já temos cache, entrega imediatamente para evitar tela vazia.
    listener({
      data: driversCache,
      hasLoadedOnce: true,
    });
  }

  return () => {
    listeners.delete(listener);

    // Sem inscritos, desligamos o listener para poupar recursos.
    if (listeners.size === 0 && firestoreUnsubscribe) {
      firestoreUnsubscribe();
      firestoreUnsubscribe = null;
    }
  };
};

export const getDriversFromCache = () => ({
  data: driversCache,
  hasLoadedOnce,
});

